import React from 'react';
import { Canvas } from '@react-three/fiber';

const CanvasWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Canvas
        orthographic
        camera={{ zoom: 80, position: [0, 0, 10] }}
        gl={{ antialias: true }}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: -1,
            background: '#111',
        }}
    >
        <fog attach="fog" args={['#111', 5, 20]} />
        <ambientLight intensity={0.5} />
        {children}
    </Canvas>
);

export default CanvasWrapper;